/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FirstPayerRow interface.
 */
export function instanceOfFirstPayerRow(value) {
    if (!('firstPaidAt' in value) || value['firstPaidAt'] === undefined)
        return false;
    if (!('firstPaidTier' in value) || value['firstPaidTier'] === undefined)
        return false;
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    return true;
}
export function FirstPayerRowFromJSON(json) {
    return FirstPayerRowFromJSONTyped(json, false);
}
export function FirstPayerRowFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstPaidAt': json['firstPaidAt'],
        'firstPaidTier': json['firstPaidTier'],
        'userId': json['userId'],
    };
}
export function FirstPayerRowToJSON(json) {
    return FirstPayerRowToJSONTyped(json, false);
}
export function FirstPayerRowToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstPaidAt': value['firstPaidAt'],
        'firstPaidTier': value['firstPaidTier'],
        'userId': value['userId'],
    };
}
